import {IRow} from '../GenericTable.vue';
import {GenericTableParameters} from './GenericTableParameters';

/** Interface de définition d'une stratégie de sélection employée par "GenericTable". */
export interface IGenericTableSelectMode {

    /** Initialise les paramètres en fonction du mode de selection */
    Initialize(): void;

    /**
     * Permute l'état de selection de toute les lignes
     * @param row Lignes dont l’état de sélection doit être inversé
     * @param isDisplayed Indique si la ligne est affichés visuelement dans la page en cours
     */
    ToggleRow(row: IRow, isDisplayed): void;

    /**
     * Permute l'état de selection de toute les lignes
     */
    ToggleRows(): void;

    /**
     * Permute l'état de selection de toute les lignes affichés sur la page en cours
     */
    ToggleDisplayedRows(): void;

}

/** Classe abstraite de définition des communs entre strategie  */
export abstract class GenericTableSelectMode implements IGenericTableSelectMode {
    /** Context : parametres de la strategie */
    protected context: GenericTableParameters;

    /** Constructeur par défaut pour conservé la transmition d'information entre les états */
    constructor(context: GenericTableParameters) {
        this.context = context;
    }

    /** Initialise les paramètres en fonction du mode de selection */
    public abstract Initialize(): void;

    /**
     * Permute l'état de selection de toute les lignes
     * @param row Lignes dont l’état de sélection doit être inversé
     *  @param isDisplayed Indique si la ligne est affichés visuelement dans la page en cours
     */
    public abstract ToggleRow(row: IRow, displayedRows: boolean): void;

    /**
     * Permute l'état de selection de toute les lignes
     */
    public abstract ToggleRows(): void;

    /**
     * Permute l'état de selection de toute les lignes affichés sur la page en cours
     */
    public abstract ToggleDisplayedRows(): void;
}
